<template>
  <div>
    <el-row :gutter="20">
      <el-col class="integration-settings" :span="20">
        <div>
          <div v-if="integrationWizardIndex >= 0">
            <h4 class="center-text">Devo API Configuration Setup</h4>
            <el-steps :active="integrationWizardIndex" finish-status="success">
              <el-step></el-step>
              <el-step></el-step>
            </el-steps>
          </div>
          <el-carousel
            ref="wizard"
            :autoplay="false"
            :loop="false"
            indicator-position="none"
            arrow="never"
            height="400"
          >
            <el-carousel-item :key="1">
              <div class="box flex center ">
                <el-form :v-model="integrationWizardForm" label-width="240px" label-position="left" class="full-width">
                  <el-form-item label="URL">
                    <el-input
                      v-model="integrationWizardData.nickName"
                      placeholder="Enter a nickname for your integration"
                      @keydown.native.space.prevent
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="URL">
                    <el-input v-model="integrationWizardData.url" placeholder="Enter a URL" :disabled="true"></el-input>
                  </el-form-item>
                  <el-form-item label="Devo API Token">
                    <el-input
                      v-model="integrationWizardData.token"
                      placeholder="Enter your Devo API Token"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Table">
                    <el-input
                      v-model="integrationWizardData.table"
                      placeholder="Enter your Table"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Log Type">
                    <el-input
                      v-model="integrationWizardData.logType"
                      placeholder="Enter your Log Type"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="flex float-right">
            <span
              v-if="integrationWizardIndex >= 1"
              class="text-underline cursor-pointer back-button"
              @click="backIntegrationStep"
            >
              Go Back
            </span>
            <el-button v-if="integrationWizardIndex == 0" size="medium" round @click="updateIntegrationSettings">
              Submit
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import integrationFormMixin from '@/components/form/integrations/integrationFormMixin'

import { DEVO_INTEGRATION_CONFIG_UPDATE_REQUEST } from '@/store/modules/integrations/devo-integration.type'
import { INTEGRATIONS_LIST_REQUEST } from '@/store/modules/integrations/integrations.type'
import { INTEGRATION_ACCOUNTS_LIST_REQUEST } from '@/store/modules/integration_accounts/integration-accounts.type'
export default {
  name: 'EditDevoIntegrationWorkflow',
  mixins: [integrationFormMixin],
  methods: {
    gotoIntegrationWorkflow () {
      this.$router.push({
        name: 'alertintegration-accounts'
      })
    },
    updateIntegrationSettings () {
      this.$store.dispatch(DEVO_INTEGRATION_CONFIG_UPDATE_REQUEST, this.integrationWizardData).then(
        resp => {
          this.nextIntegrationStep()
          this.apiCall.outbound = false
        },
        errMsg => {
          this.nextIntegrationStep()
          this.apiCall.error = true
          this.apiCall.errorMsg = errMsg
        }
      )
    },
    callApi () {
      this.$store.dispatch(INTEGRATIONS_LIST_REQUEST).then(integrations => {
        this.$store.dispatch(INTEGRATION_ACCOUNTS_LIST_REQUEST).then(agents => {
          this.apiCalled = true
          for (let alertIntegrationAccount of this.alertIntegrationAccounts.models) {
            if (this.$route.params.accountKey === alertIntegrationAccount.accountKey) {
              this.integrationWizardData = alertIntegrationAccount.config
              this.integrationWizardData.accountKey = alertIntegrationAccount.accountKey
              this.integrationWizardData.active = true
              this.integrationWizardData.key = alertIntegrationAccount.accountKey
            }
          }
        })
      })
    }
  },
  created () {
    if (!_.isEmpty(this.devoIntegrationConfig)) {
      this.integrationWizardData = this.devoIntegrationConfig
    }
    if (!this.$_.isEmpty(this.$route.params) && this.integrationWizardData.nickName === null) {
      this.callApi()
    }
  },
  computed: {
    ...mapGetters(['devoIntegrationConfig', 'alertIntegrationAccounts'])
  },
  watch: {},
  components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/integration_workflow.css';
</style>



// WEBPACK FOOTER //
// src/components/form/integrations/edit/EditDevoIntegrationWorkflow.vue